import { useQuery } from '@tanstack/react-query';

import {
  getPolicyPackageById,
  type GetPolicyPackageByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function usePolicyPackage(
  partyId: string,
  policyPackageId: string,
  options?: QueryOptions<GetPolicyPackageByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.policyPackages.byId(partyId, policyPackageId),
    queryFn: () =>
      getPolicyPackageById(
        { path: { party_id: partyId, policy_package_id: policyPackageId } },
        wgApi,
      ),
    ...options,
  });
}
